import { render, staticRenderFns } from "./91job.vue?vue&type=template&id=8138902c"
import script from "./91job.vue?vue&type=script&lang=js"
export * from "./91job.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports